module.exports = __webpack_public_path__ + "static/media/sbirka-link.6c207d83.jpg";